import { atom, selector } from "recoil";
const TOKEN_KEY = 'jwtToken';
const BO_USER = 'yeqolaUser';


export const isLoggedin = selector({
  key: 'isLoggedin',
  get: ({get}) => {
    if (localStorage.getItem(TOKEN_KEY)) {
        return true;
    }
    else
    {
      return false;
    }
  },
  set: ({set}, newValue) => {
    //alert('>> set >> ' + newValue);
    localStorage.setItem(TOKEN_KEY, newValue); // Update localStorage
    //set(userState, newValue); // Set the new value for the userState
    //alert('>> set >> ' + newValue); localStorage.setItem("jwtToken", res.jwt_token);
  }
});

export const userState = selector({
  key: 'userState',
  get: ({get}) => {
    if (localStorage.getItem(BO_USER)) {
        return localStorage.getItem(BO_USER);
    }
    else
    {
      return null;
    }
  },
  set: ({set}, newValue) => {
    //alert('>> set >> ' + newValue);
    localStorage.setItem(BO_USER, newValue); // Update localStorage
    //set(userState, newValue); // Set the new value for the userState
    //alert('>> set >> ' + newValue);
  }
});

export const authState = atom({
  key: 'authState',
  default: '0',
});



export const animeTitles = atom({
  key: "animeTitleList",
  default: [],
});
